export const RENT_BUTTON_CLICK_EVENT = 'rent_button_click_event'
